import SettingsToggle from "./SettingsToggle";
import SettingsHeader from "./SettingsHeader";
import SettingsForm from "./SettingsForm";
import { useSidebarState, useSidebarDispatch } from "../../context/sidebar";
import { BaseSetting, useSettingsState } from "../../context/settings";
import { useFieldsState } from "../../context/fields";
import { UserState } from "../../context/auth";
import DashboardColumnSettings from "./DashboardColumnSettings";
import { useMemo } from "react";

const DashboardSettings = ({
  user,
  loadingState,
}: {
  user: UserState;
  loadingState: (newValue: boolean) => void;
}) => {
  const { open, settingsOpen } = useSidebarState();
  const {
    fieldsSettings: { visibility },
  } = useSettingsState();
  const { fields } = useFieldsState();
  const settings = useMemo(
    () =>
      visibility &&
      fields.map<BaseSetting>((f) => {
        const existing = visibility.find(
          (v) => v.field_id === f.id && v.type === "field"
        );
        return {
          id: existing?.id ?? `new-${f.id}`,
          field_id: f.id,
          type: "field",
          label: f.name,
          ref: null,
          client_id: user.client.id!,
          hidden: existing?.hidden ?? 0,
          order: existing?.order ?? 0,
        };
      }),
    [fields, user, visibility]
  );
  const sidebarDispatch = useSidebarDispatch();
  const toggleDisplay = () => {
    !open && sidebarDispatch({ type: "setOpen", payload: !open });
    sidebarDispatch({ type: "setSettingsOpen", payload: !settingsOpen });
  };

  if (open && settingsOpen) {
    return (
      <>
        <SettingsForm
          user={user}
          label="field"
          items={settings}
          subheader={<SettingsHeader close={toggleDisplay} />}
          setLoading={(state) => loadingState(state)}
        />
        <DashboardColumnSettings user={user} />
      </>
    );
  } else {
    return <SettingsToggle click={toggleDisplay} />;
  }
};

export default DashboardSettings;
